import axios from 'axios';
import { Dispatch } from 'react';
import { AnyIfEmpty } from 'react-redux';
import {
    GET_VISITOR_LIST_REQUEST,
    GET_VISITOR_LIST_SUCCESS,
    GET_VISITOR_LIST_FAILURE,
    GET_VISITOR_LIST_BY_ID_REQUEST,
    GET_VISITOR_LIST_BY_ID_SUCCESS,
    GET_VISITOR_LIST_BY_ID_FAILURE,
    CREATE_VISITOR_REQUEST,
    CREATE_VISITOR_FAILURE,
    CREATE_VISITOR_SUCCESS,
    EDIT_VISITOR_REQUEST,
    EDIT_VISITOR_SUCCESS,
    EDIT_VISITOR_FAILURE,
    CLEAR_VISITOR_DATA,
} from '../constants/visitor-list.constants';

const getvisitorListRequest = () => {
    return {
        type: GET_VISITOR_LIST_REQUEST,
    };
};

const getvisitorListSuccess = (getVisitorListData: AnyIfEmpty<object>) => {
    return {
        type: GET_VISITOR_LIST_SUCCESS,
        payload: getVisitorListData,
    };
};

const getvisitorListFailure = (getVisitorListError: string) => {
    return {
        type: GET_VISITOR_LIST_FAILURE,
        payload: getVisitorListError,
    };
};

const getvisitorListByIdRequest = () => {
    return {
        type: GET_VISITOR_LIST_BY_ID_REQUEST,
    };
};

const getvisitorListByIdSuccess = (getVisitorListData: AnyIfEmpty<object>) => {
    return {
        type: GET_VISITOR_LIST_BY_ID_SUCCESS,
        payload: getVisitorListData,
    };
};

const getvisitorListByIdFailure = (getVisitorListError: string) => {
    return {
        type: GET_VISITOR_LIST_BY_ID_FAILURE,
        payload: getVisitorListError,
    };
};

const createVisitorRequest = () => {
    return {
        type: CREATE_VISITOR_REQUEST,
    };
};

const createVisitorSuccess = (visitorData: AnyIfEmpty<object>) => {
    return {
        type: CREATE_VISITOR_SUCCESS,
        payload: visitorData,
    };
};

const createVisitorFailure = (visitorData: AnyIfEmpty<object>) => {
    return {
        type: CREATE_VISITOR_FAILURE,
        payload: visitorData,
    };
};

const editVisitorRequest = () => {
    return {
        type: EDIT_VISITOR_REQUEST,
    };
};

const editVisitorSuccess = (visitorData: AnyIfEmpty<object>) => {
    return {
        type: EDIT_VISITOR_SUCCESS,
        payload: visitorData,
    };
};

const editVisitorFailure = (visitorData: AnyIfEmpty<object>) => {
    return {
        type: EDIT_VISITOR_FAILURE,
        payload: visitorData,
    };
};

export const getvisitorList = (obj: any) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getvisitorListRequest());
        return await axios
            .post(`/user-admin/visitors`, obj)
            .then((response) => {
                dispatch(getvisitorListSuccess(response.data));
            })
            .catch((err) => dispatch(getvisitorListFailure(err.message)));
    };
};

export const getvisitorListById = (id: string) => {
    return async (dispatch: AnyIfEmpty<object>) => {
        dispatch(getvisitorListByIdRequest());
        return await axios
            .get(`/user-admin/${id}`)
            .then((response) => {
                dispatch(getvisitorListByIdSuccess(response.data));
            })
            .catch((err) => dispatch(getvisitorListByIdFailure(err.message)));
    };
};

export const createVisitor = (visitorObj: AnyIfEmpty<object>) => {
    return async (dispatch: Dispatch<any>) => {
        dispatch(createVisitorRequest());
        return await axios
            .post('/user-admin', visitorObj)
            .then((response) => dispatch(createVisitorSuccess(response.data)))
            .catch((err) => dispatch(createVisitorFailure(err)));
    };
};

export const editVisitor = (id: string, visitorObj: AnyIfEmpty<object>) => {
    return async (dispatch: Dispatch<any>) => {
        dispatch(editVisitorRequest());
        return await axios
            .patch(`/user-admin/${id}`, visitorObj)
            .then((response) => dispatch(editVisitorSuccess(response.data)))
            .catch((err) => dispatch(editVisitorFailure(err)));
    };
};

const clearVisitorData = () => {
    return {
        type: CLEAR_VISITOR_DATA,
    };
};

export const clearVisitor = () => {
    return async (dispatch: Dispatch<any>) => {
        dispatch(clearVisitorData());
    };
};
